import React, { useRef, useState } from "react";
import { useRoute } from "@react-navigation/native";
import { RootRouteProps } from "routers/types/stack";

import { View, TextInput } from "react-native";
import {
  Toast,
  Input,
  Error,
  Header,
  Button,
  Loading,
  InputLabel,
} from "components";
import Tabs from "./tabs";
import css from "styles";
import { strings } from "assets/constants";

import { useForm, Controller } from "react-hook-form";
import { useCustomer, useAddCustomer } from "clients/apis";
import { alertPermission, sn } from "utils";
import { useChmod } from "hooks";

export default function Customer() {
  const { chmod } = useChmod();

  const { data: routeParamData } =
    useRoute<RootRouteProps<"customer">>().params;
  const initial = routeParamData as CustomerT;
  const headerTitle = initial
    ? strings.edit_info + " " + initial?.name
    : strings.add_customer;

  const [customerId, setCustomerId] = useState<number | undefined>(initial?.id);
  const { isLoading, data, isError, error, refetch, isRefetching } =
    useCustomer(customerId);

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors: inputErrors },
  } = useForm<CustomerFormDataT>({ defaultValues: { name: "", mobile: "" } });

  const mobileInput = useRef<TextInput>();
  const _focusOnMobileInput = () => mobileInput.current?.focus();

  const addCustomerMut = useAddCustomer();

  const _onSubmit = () =>
    addCustomerMut.mutate(
      { name: getValues().name, mobile: getValues().mobile },
      {
        onSuccess: (res) => {
          Toast.success({ message: res.data.message });
          setCustomerId(res.data.customer_id);
        },
      }
    );

  const _renderPrimaryInfoInputs = () => {
    return (
      <>
        <View style={css.responsiveInputsListContainer}>
          <View style={css.responsiveInputContainer}>
            <InputLabel label={strings.name} />
            <Controller
              control={control}
              name="name"
              rules={{
                required: {
                  value: true,
                  message: strings.customer_name_is_required,
                },
              }}
              render={({ field: { value, onChange } }) => (
                <Input
                  placeholder={strings.insert_customer_name}
                  icon={{ name: "user" }}
                  onChangeText={onChange}
                  value={value}
                  onSubmitEditing={_focusOnMobileInput}
                  error={inputErrors.name?.message}
                />
              )}
            />
          </View>

          <View style={css.responsiveInputContainer}>
            <InputLabel label={strings.mobile} />
            <Controller
              control={control}
              name="mobile"
              rules={{
                required: {
                  value: true,
                  message: strings.customer_mobile_is_required,
                },
                // pattern: {
                //   value: patterns.mobile,
                //   message: strings.invalid_mobile,
                // },
              }}
              render={({ field: { value, onChange } }) => (
                <Input
                  value={value}
                  // maxLength={11}
                  inputRef={mobileInput}
                  onChangeText={onChange}
                  keyboardType="phone-pad"
                  icon={{ name: "smartphone" }}
                  error={inputErrors.mobile?.message}
                  onSubmitEditing={handleSubmit(_onSubmit)}
                  placeholder={strings.insert_customer_mobile}
                />
              )}
            />
          </View>
        </View>

        <View
          style={{
            marginTop: 60,
            maxWidth: sn("100%", "100%", 300, 300),
            ...css.paddingH,
          }}
        >
          <Button
            title={{ value: strings.submit_info }}
            onPress={
              chmod("customer", "POST")
                ? handleSubmit(_onSubmit)
                : alertPermission
            }
            loading={addCustomerMut.isLoading}
          />
        </View>
      </>
    );
  };

  const _renderContent = () => {
    if (isLoading && initial?.id) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data) {
      return <Tabs data={data?.data} />;
    }

    return _renderPrimaryInfoInputs();
  };

  return (
    <>
      <Header title={headerTitle} />
      {_renderContent()}
    </>
  );
}
